// ============== CALENDRIER CCQ ==============
// Jours fériés chômés CCQ et congés annuels obligatoires
// Source: Commission de la construction du Québec

// Jours fériés chômés CCQ 2025
const JOURS_FERIES_CCQ_2025 = [
  { date: '2025-01-01', nom: "Jour de l'An" },
  { date: '2025-01-02', nom: "Lendemain du Jour de l'An" },
  { date: '2025-04-18', nom: 'Vendredi saint' },
  { date: '2025-04-21', nom: 'Lundi de Pâques' },
  { date: '2025-05-19', nom: 'Journée nationale des patriotes' },
  { date: '2025-06-24', nom: 'Fête nationale du Québec' },
  { date: '2025-07-01', nom: 'Fête du Canada' },
  { date: '2025-09-01', nom: 'Fête du Travail' },
  { date: '2025-10-13', nom: 'Action de grâce' },
  { date: '2025-12-25', nom: 'Noël' },
];

// Jours fériés chômés CCQ 2026
const JOURS_FERIES_CCQ_2026 = [
  { date: '2026-01-01', nom: "Jour de l'An" },
  { date: '2026-01-02', nom: "Lendemain du Jour de l'An" },
  { date: '2026-04-03', nom: 'Vendredi saint' },
  { date: '2026-04-06', nom: 'Lundi de Pâques' },
  { date: '2026-05-18', nom: 'Journée nationale des patriotes' },
  { date: '2026-06-24', nom: 'Fête nationale du Québec' },
  { date: '2026-07-01', nom: 'Fête du Canada' },
  { date: '2026-09-07', nom: 'Fête du Travail' },
  { date: '2026-10-12', nom: 'Action de grâce' },
  { date: '2026-12-25', nom: 'Noël' },
];

// Jours fériés chômés CCQ 2027
const JOURS_FERIES_CCQ_2027 = [
  { date: '2027-01-01', nom: "Jour de l'An" },
  { date: '2027-01-02', nom: "Lendemain du Jour de l'An" },
  { date: '2027-03-26', nom: 'Vendredi saint' },
  { date: '2027-03-29', nom: 'Lundi de Pâques' },
  { date: '2027-05-24', nom: 'Journée nationale des patriotes' },
  { date: '2027-06-24', nom: 'Fête nationale du Québec' },
  { date: '2027-07-01', nom: 'Fête du Canada' },
  { date: '2027-09-06', nom: 'Fête du Travail' },
  { date: '2027-10-11', nom: 'Action de grâce' },
  { date: '2027-12-25', nom: 'Noël' },
];

const ALL_JOURS_FERIES = [
  ...JOURS_FERIES_CCQ_2025,
  ...JOURS_FERIES_CCQ_2026,
  ...JOURS_FERIES_CCQ_2027,
];

// Congés annuels obligatoires CCQ
const CONGES_CCQ = {
  hiver_2024_2025: { debut: '2024-12-22', fin: '2025-01-04', nom: "Congé annuel d'hiver 2024-2025" },
  ete_2025: { debut: '2025-07-20', fin: '2025-08-02', nom: "Congé annuel d'été 2025" },
  hiver_2025_2026: { debut: '2025-12-21', fin: '2026-01-03', nom: "Congé annuel d'hiver 2025-2026" },
  ete_2026: { debut: '2026-07-19', fin: '2026-08-01', nom: "Congé annuel d'été 2026" },
  hiver_2026_2027: { debut: '2026-12-20', fin: '2027-01-02', nom: "Congé annuel d'hiver 2026-2027" },
  ete_2027: { debut: '2027-07-18', fin: '2027-07-31', nom: "Congé annuel d'été 2027" },
};

// Vérifie si une date (format YYYY-MM-DD) est un jour férié CCQ
export const isJourFerieCCQ = (dateStr) => {
  return ALL_JOURS_FERIES.find(jf => jf.date === dateStr) || null;
};

// Vérifie si une date est dans un congé annuel obligatoire CCQ
export const isCongeCCQ = (dateStr) => {
  for (const conge of Object.values(CONGES_CCQ)) {
    if (dateStr >= conge.debut && dateStr <= conge.fin) {
      return conge;
    }
  }
  return null;
};

// Retourne toutes les infos CCQ pour une date
export const getCCQInfo = (dateStr) => {
  const jourFerie = isJourFerieCCQ(dateStr);
  const conge = isCongeCCQ(dateStr);
  return { jourFerie, conge };
};

// Retourne les jours fériés CCQ pour un mois donné (year, month 0-indexed)
export const getJoursFeriesForMonth = (year, month) => {
  const monthStr = `${year}-${String(month + 1).padStart(2, '0')}`;
  return ALL_JOURS_FERIES.filter(jf => jf.date.startsWith(monthStr));
};

// Retourne les jours de congé obligatoire CCQ pour un mois donné
export const getCongesCCQForMonth = (year, month) => {
  const startOfMonth = `${year}-${String(month + 1).padStart(2, '0')}-01`;
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const endOfMonth = `${year}-${String(month + 1).padStart(2, '0')}-${String(daysInMonth).padStart(2, '0')}`;
  
  const result = [];
  for (const conge of Object.values(CONGES_CCQ)) {
    if (conge.debut <= endOfMonth && conge.fin >= startOfMonth) {
      result.push(conge);
    }
  }
  return result;
};

export { JOURS_FERIES_CCQ_2025, JOURS_FERIES_CCQ_2026, JOURS_FERIES_CCQ_2027, ALL_JOURS_FERIES, CONGES_CCQ };
